import "./Home.scss";

import { Container } from "@/mcn-react-ui";

import useScrollAnimation from "../../hooks/useScrollAnimation";
import About from "./About/About";
import Contact from "./Contact/Contact";
import Faq from "./Faq/Faq";
import Hero from "./Hero/Hero";
import OpenSource from "./OpenSource/OpenSource";
import Portfolio from "./Portfolio/Portfolio";
import Services from "./Services/Services";
import Team from "./Team/Team";

const Home = () => {
  useScrollAnimation();

  return (
    <Container className="home">
      <Hero />
      <Services />
      <About />
      <Team />
      <OpenSource />
      <Portfolio />
      <Faq />
      <Contact />
    </Container>
  );
};

export default Home;
